const rulesEnum = {
  eType: {
    Precedence: "PRECEDENCE",
    Cumulative: "CUMULATIVE",
  },
  ePriority: {
    Relationship: "RELATIONSHIP",
    Offer: "OFFER",
    Global: "GLOBAL",
  },
  eTargetType: {
    Global: "GLOBAL",
    Terminal: "TERMINAL",
    Network: "NETWORK",
    Product: "PRODUCT",
    Offer: "OFFER",
    Account: "ACCOUNT",
  },
  eUnitType: {
    PencePerLitre: {
      id: "PPL",
      display: "ppl",
    },
    UsdPerMetricTonne: {
      id: "USD/METRIC_TONNE",
      display: "USD/mt",
    },
    UsdPerTonne: {
      id: "USD/TONNE",
      display: "USD/TONNE",
    },
    EurPerTonne: {
      id: "EUR/TONNE",
      display: "EUR/TONNE",
    },
    GbpUsd: {
      id: "GBP/USD",
      display: "GBP/USD",
    },
    IceMonth: {
      id: "ICE_MONTH",
      display: "M",
    },
    LitresPerMetricTonne: {
      id: "L/METRIC_TONNE",
      display: "L/mT",
    },
    Celsius: {
      id: "CELSIUS",
      display: "°C",
    },
  },
  eTargetAttributeType: {
    Duty: "DUTY",
    Density: "DENSITY",
    BioBlend: "BIO_BLEND",
    Fx: "FX",
    FxLive: "FX_LIVE",
    IceLive: "ICE_LIVE",
    IceLivePremium: "ICE_LIVE_PREMIUM",
    IceLivePrice: "ICE_LIVE_PRICE",
    IceSettle: "ICE_SETTLE",
    ProductSettle: "PRODUCT_SETTLE",
    Price: "PRICE",
  },
  eOfferExclusion: {
    LiveSpot: "LIVE_SPOT",
    FixedSpot: "FIXED_SPOT",
    D1Spot: "D1_SPOT",
    D2Spot: "D2_SPOT",
    LiveContract: "LIVE_CONTRACT",
    FixedContract: "FIXED_CONTRACT",
    D1Contract: "D1_CONTRACT",
    D2Contract: "D2_CONTRACT",
    PriceInputTypeTotal: "PRICE_INPUT_TYPE_TOTAL",
    StandardMeasurement: "STANDARD_MEASUREMENT",
  },
};

export { rulesEnum };
